import { globalColors } from "assets/colors-global";

/**
 * The base colors for the .
 * You can add new color using this file.
 * You can customized the colors for the entire  using thie file.
 */

// types
interface ColorsTypes {
  main: string;
  focus: string;
  text?: string;
}

interface GradientsTypes {
  main: string;
  state: string;
}

interface SocialMediaColorsTypes {
  main: string;
  dark: string;
}

interface BadgeColorsTypes {
  background: string;
  text: string;
}

interface Types {
  cardTitleContrast: { main: string };
  background:
    | {
        default: string;
        sidenav?: string;
        card?: string;
      }
    | any;
  white:
    | {
        main: string;
        focus: string;
      }
    | any;
  text:
    | {
        main: string;
        focus: string;
        primary?: string;
        secondary?: string;
        disabled?: string;
      }
    | any;
  transparent:
    | {
        main: string;
      }
    | any;
  black:
    | {
        light: string;
        main: string;
        focus: string;
      }
    | any;
  primary: ColorsTypes | any;
  contrast: ColorsTypes | any;
  secondary: ColorsTypes | any;
  info: ColorsTypes | any;
  success: ColorsTypes | any;
  warning: ColorsTypes | any;
  error: ColorsTypes | any;
  light: ColorsTypes | any;
  dark: ColorsTypes | any;
  grey:
    | {
        [key: string | number]: string;
      }
    | any;
  gradients:
    | {
        primary: GradientsTypes;
        secondary: GradientsTypes;
        info: GradientsTypes;
        success: GradientsTypes;
        warning: GradientsTypes;
        error: GradientsTypes;
        light: GradientsTypes;
        dark: GradientsTypes;
      }
    | any;
  socialMediaColors:
    | {
        facebook: SocialMediaColorsTypes;
        twitter: SocialMediaColorsTypes;
        instagram: SocialMediaColorsTypes;
        linkedin: SocialMediaColorsTypes;
        pinterest: SocialMediaColorsTypes;
        youtube: SocialMediaColorsTypes;
        vimeo: SocialMediaColorsTypes;
        slack: SocialMediaColorsTypes;
        dribbble: SocialMediaColorsTypes;
        github: SocialMediaColorsTypes;
        reddit: SocialMediaColorsTypes;
        tumblr: SocialMediaColorsTypes;
      }
    | any;
  badgeColors:
    | {
        primary: BadgeColorsTypes;
        secondary: BadgeColorsTypes;
        info: BadgeColorsTypes;
        success: BadgeColorsTypes;
        warning: BadgeColorsTypes;
        error: BadgeColorsTypes;
        light: BadgeColorsTypes;
        dark: BadgeColorsTypes;
      }
    | any;
  coloredShadows:
    | {
        [key: string]: string;
      }
    | any;
  inputBorderColor: string;
  inputFormBorderColor: string;
  tabs:
    | {
        indicator:
          | {
              boxShadow: string;
            }
          | any;
      }
    | any;
}

const colors: Types = {
  background: {
    default: globalColors.primary2.main,
    sidenav: globalColors.secondary2.main,
    paper: globalColors.secondary2.main,
    card: globalColors.secondary2.main,
  },

  text: {
    main: globalColors.primary3.main,
    focus: globalColors.primary3.main,
    primary: globalColors.primary3.main,
    secondary: globalColors.secondary4.main,
    contrast: globalColors.secondary2.main,
    error: globalColors.secondary6.main,
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: globalColors.primary3.main,
    focus: globalColors.primary3.main,
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#000000",
  },
  primary: {
    main: globalColors.primary1.main,
    contrastText: globalColors.primary3.main,
  },
  contrast: {
    main: globalColors.primary1.main,
    contrastText: globalColors.primary3.main,
  },
  secondary: {
    main: globalColors.secondary1.main,
    contrastText: globalColors.primary3.main,
  },

  info: {
    main: globalColors.primary3.main,
    state: globalColors.primary3.main,
    contrastText: globalColors.primary2.main,
  },

  success: {
    main: globalColors.secondary7.main,
    // focus: "#67bb6a",
  },

  warning: {
    main: "#fb8c00",
    focus: "#fc9d26",
  },

  error: {
    main: globalColors.secondary6.main,
    focus: "#f65f53",
  },

  light: {
    main: "#F5F5F566",
    focus: "#F5F5F566",
  },

  dark: {
    main: globalColors.darkPass.main,
    focus: globalColors.darkPass.main,
  },

  grey: {
    100: "#f8f9fa",
    200: "#F5F5F5",
    300: "#dee2e6",
    400: "#ced4da",
    500: "#adb5bd",
    600: globalColors.secondary3.main,
    700: "#495057",
    800: "#343a40",
    900: "#212529",
  },

  gradients: {
    primary: {
      main: "#EC407A",
      state: "#D81B60",
    },

    secondary: {
      main: globalColors.secondary4.main,
      state: globalColors.secondary4.main,
    },

    info: {
      main: globalColors.secondary3.main,
      state: globalColors.secondary3.main,
    },

    success: {
      main: "#66BB6A",
      state: "#43A047",
    },

    warning: {
      main: "#FFA726",
      state: "#FB8C00",
    },

    error: {
      main: "#EF5350",
      state: "#E53935",
    },

    light: {
      main: "#EBEFF4",
      state: "#CED4DA",
    },

    dark: {
      main: "#323a54",
      state: "#1a2035",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  badgeColors: {
    primary: {
      background: "#f8b3ca",
      text: "#cc084b",
    },

    secondary: {
      background: "#d7d9e1",
      text: globalColors.secondary3.main,
    },

    info: {
      background: globalColors.secondary3.main + "60",
      text: globalColors.secondary3.main,
    },

    success: {
      background: globalColors.secondary7.main + "25",
      text: globalColors.secondary7.main,
    },

    warning: {
      background: "#ffd59f",
      text: "#c87000",
    },
    error: {
      background: globalColors.secondary6.main + "25",
      text: globalColors.secondary6.main,
    },
    light: {
      background: globalColors.secondary4.main,
      text: "#c7d3de",
    },

    dark: {
      background: "#8097bf",
      text: "#1e2e4a",
    },
  },

  coloredShadows: {
    primary: "#e91e62",
    secondary: "#110e0e",
    info: "#00bbd4",
    success: "#4caf4f",
    warning: "#ff9900",
    error: "#f44336",
    light: "#adb5bd",
    dark: "#404040",
  },

  inputBorderColor: "#d2d6da",
  inputFormBorderColor: globalColors.secondary3.main,
  cardTitleContrast: {
    main: globalColors.secondary4.main,
  },
  tabs: {
    indicator: { boxShadow: "#ddd" },
  },
};

export default colors;
